import { render, staticRenderFns } from "./FileUploadTile.vue?vue&type=template&id=6aa84424&scoped=true"
import script from "./FileUploadTile.vue?vue&type=script&lang=js"
export * from "./FileUploadTile.vue?vue&type=script&lang=js"
import style0 from "./FileUploadTile.vue?vue&type=style&index=0&id=6aa84424&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa84424",
  null
  
)

export default component.exports